import { DateTime } from 'luxon';

export interface CreditCardForm {
  cardOwner: string;
  cardNumber: string;
  expiryMonth: number;
  expiryYear: number;
  cvc: string;
  instalment: number;
}

export const creditCardFormOutputTransformer = (
  creditCardForm: CreditCardForm,
) => ({
  KK_Sahibi: creditCardForm.cardOwner,
  KK_No: creditCardForm.cardNumber,
  KK_SK_Ay: creditCardForm.expiryMonth,
  KK_SK_Yil: creditCardForm.expiryYear,
  KK_CVC: creditCardForm.cvc,
  Taksit: creditCardForm.instalment,
});

export const getEmptyCreditCardForm = (): CreditCardForm => {
  const now = DateTime.now();

  return {
    cardOwner: '',
    cardNumber: '',
    expiryMonth: now.month,
    expiryYear: now.year,
    cvc: '',
    instalment: 1,
  };
};
